import { ToastConfig } from '@ngneat/hot-toast';

export const HOT_TOAST_CONFIG: Partial<ToastConfig> = {
  position: 'bottom-center',
  stacking: 'depth',
  dismissible: true,
  closeStyle: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 'auto',
    height: 'calc(100% - 9px)',
    marginTop: 0,
    fontSize: 0,
    backgroundColor: 'transparent',
  },
  style: {
    fontSize: '18px',
    maxWidth: '600px',
  },
};
